var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Page } from "../../lib/page-component";
import "../../components/header";
import "../../components/leftMenu";
import KnockoutModel from "../../lib/knockout_model";
import * as authorization from "../../lib/authorization";
import * as ajax from "../../app-lib/ajax_proxy";
import '../../lib/knockout_datePicker';
import "../../components/paging";
import './addOpponet.css';
var opponetModel = /** @class */ (function (_super) {
    __extends(opponetModel, _super);
    function opponetModel(root) {
        var _this = _super.call(this, "", root, {}) || this;
        _this.isCheck = ko.observable(false); //是否是查看
        _this.dataId = ko.observable('0000'); //项目id  0000时新增 
        _this.local = ko.observableArray(); //省份列表
        _this.localid = ko.observable(); //省份obj
        _this.localnext = ko.observable(); //城市列表
        _this.localsomeid = ko.observable(); //城市obj
        _this.opponetobj = ko.observable({
            name: ko.observable(), mind: ko.observable(), situation: ko.observable(), slogan: ko.observable(), cooperationMode: ko.observable(),
            service: ko.observable(), partAdvantages: ko.observable(), caseAnalysis: ko.observable(), area: ko.observable()
        }); //竞争对手数据
        return _this;
    }
    // 返回
    opponetModel.prototype.goBack = function () {
        history.go(-1);
        this.resetData();
    };
    // 新建，编辑提交
    opponetModel.prototype.subData = function () {
        var _this = this;
        // 必填项校验
        if (!this.opponetobj().name()) {
            return window.popBox.show('请填写公司名称');
        }
        // if (this.opponetobj().name().length > 40) {
        //     return window.popBox.show('公司名称不能大于40个字符');
        // }
        if (!this.opponetobj().situation()) {
            return window.popBox.show('请填写公司情况概述');
        }
        // if (this.opponetobj().situation().length > 400) {
        //     return window.popBox.show('公司情况概述不能大于400个字符');
        // }
        if (!this.opponetobj().cooperationMode()) {
            return window.popBox.show('请填写合作模式');
        }
        // if (this.opponetobj().cooperationMode().length > 400) {
        //     return window.popBox.show('合作模式不能大于400个字符');
        // }
        if (!this.opponetobj().service()) {
            return window.popBox.show('请填写服务优劣');
        }
        // if (this.opponetobj().service().length > 400) {
        //     return window.popBox.show('服务优劣不能大于400个字符');
        // }
        if (!this.opponetobj().partAdvantages()) {
            return window.popBox.show('请填写区域优势');
        }
        // if (this.opponetobj().partAdvantages().length > 400) {
        //     return window.popBox.show('区域优势不能大于400个字符');
        // }
        if (!this.opponetobj().caseAnalysis()) {
            return window.popBox.show('请填写案例分析');
        }
        // if (this.opponetobj().caseAnalysis().length > 400) {
        //     return window.popBox.show('案例分析不能大于400个字符');
        // }
        //非必填项校验
        // if (this.opponetobj().mind()) {
        //     if (this.opponetobj().mind().length > 400) {
        //         return window.popBox.show('核心理念不能大于400个字符');
        //     }
        // }
        // if (this.opponetobj().slogan()) {
        //     if (this.opponetobj().slogan().length > 400) {
        //         return window.popBox.show('营销口号不能大于400个字符');
        //     }
        // }
        if (this.opponetobj().area()) {
            if (this.opponetobj().area().length > 15) {
                return window.popBox.show('本年度签约面积不能大于15位数');
            }
        }
        ajax.post('/api/competitor/' + this.dataId(), {
            authorId: authorization.getUserId(),
            authorName: authorization.getUsername(),
            name: this.opponetobj().name(),
            mind: this.opponetobj().mind(),
            situation: this.opponetobj().situation(),
            slogan: this.opponetobj().slogan(),
            cooperationMode: this.opponetobj().cooperationMode(),
            service: this.opponetobj().service(),
            partAdvantages: this.opponetobj().partAdvantages(),
            caseAnalysis: this.opponetobj().caseAnalysis(),
            area: this.opponetobj().area(),
        }).then(function (d) {
            if (d.status == '0') {
                if (_this.dataId() == '0000') {
                    window.popBox.show('新增成功').then(function (d) {
                        _this.goBack();
                    });
                }
                else {
                    window.popBox.show('编辑成功').then(function (d) {
                        _this.goBack();
                    });
                }
            }
        }).catch(function (err) {
            if (err.status == '2') {
                window.popBox.show(err.message);
            }
        });
    };
    // 取消
    opponetModel.prototype.quick = function () {
        this.resetData();
        this.goBack();
    };
    // 重置
    opponetModel.prototype.resetData = function () {
        if (this.dataId() == '0000') {
            this.opponetobj({
                name: ko.observable(), mind: ko.observable(), situation: ko.observable(), slogan: ko.observable(), cooperationMode: ko.observable(),
                service: ko.observable(), partAdvantages: ko.observable(), caseAnalysis: ko.observable(), area: ko.observable()
            });
        }
        else {
            this.getMarketData();
        }
    };
    opponetModel.prototype.clear = function () {
        this.opponetobj({
            name: ko.observable(), mind: ko.observable(), situation: ko.observable(), slogan: ko.observable(), cooperationMode: ko.observable(),
            service: ko.observable(), partAdvantages: ko.observable(), caseAnalysis: ko.observable(), area: ko.observable()
        });
    };
    // 获取数据
    opponetModel.prototype.getMarketData = function () {
        var _this = this;
        ajax.get('/api/competitor/' + this.dataId()).then(function (d) {
            _this.opponetobj().name(d.data.name);
            _this.opponetobj().mind(d.data.mind);
            _this.opponetobj().situation(d.data.situation);
            _this.opponetobj().slogan(d.data.slogan);
            _this.opponetobj().cooperationMode(d.data.cooperationMode);
            _this.opponetobj().service(d.data.service);
            _this.opponetobj().partAdvantages(d.data.partAdvantages);
            _this.opponetobj().caseAnalysis(d.data.caseAnalysis);
            _this.opponetobj().area(d.data.area);
        });
    };
    return opponetModel;
}(KnockoutModel));
var opModel = /** @class */ (function (_super) {
    __extends(opModel, _super);
    function opModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    opModel.prototype.init = function () {
        this.vm = new opponetModel(this.container.querySelector('.addOpponet'));
        this.vm.bind();
    };
    opModel.prototype.update = function (arg) {
        this.vm.dataId('0000');
        this.vm.clear();
        if (arg.routeData.query.isCheck) {
            if (arg.routeData.query.isCheck == 'yes') {
                this.vm.isCheck(true);
            }
            else {
                this.vm.isCheck(false);
            }
        }
        if (arg.routeData.query.dataId) {
            this.vm.dataId(arg.routeData.query.dataId);
            this.vm.getMarketData();
        }
        return Promise.resolve();
    };
    opModel.prototype.onInitComplete = function () {
    };
    return opModel;
}(Page));
export default opModel;
